<template>
	<div class="centerWidth">
		<!-- <div class="gaokao-nav">
			<span>个人中心 ></span>
			<span>一键志愿填报</span>
		</div> -->
		<section class="gaokao-content">
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>1</p>
							<span>信息校对</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>2</p>
							<span>选择填报批次</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>3</p>
							<span>填写志愿表</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>4</p>
							<span>生成志愿表</span>
						</div>
					</div>
				</li>
			</ul>
			<article class="enroll-info">
				<p class="enroll-tit">本次录取信息</p>
				<div class="flex zhong float">
					<div class="enroll-left">
						<div class="enroll-lc01">
							<span>生源地：</span>
							<input placeholder="" disabled="true" v-model="cityName" />
						</div>
						<div class="enroll-lc01">
							<span>科目：</span>
							<input placeholder="" disabled="true" v-model="subjectStr" />
						</div>
						<div class="enroll-lc01">
							<span>分数：</span>
							<input placeholder="" disabled="true" v-model="branchStr" />
						</div>
					</div>
					<p class="enroll-right" @click="onXiuShow()">修改</p>
				</div>
				<button class="gaokao-btn enroll-btn" @click="goNextb()">前往填写志愿表</button>
			</article>
			<p class="test-tit">我的志愿表</p>
			<article class="enroll-table">
				<table class="enroll-table-con" cellpadding="0" cellspacing="0" align="center" rules="none">
					<tr>
						<th>编号</th>
						<th>科目</th>
						<th>分数</th>
						<th>更新时间</th>
						<th>操作</th>
					</tr>
					<tr v-for="(item, index) in List" :key="index">
						<td>{{ index + 1 }}</td>
						<td>{{ item.Subject }}</td>
						<td>{{ item.Branch }}</td>
						<td>{{ item.CreateTime }}</td>
						<td>
							<span @click="lukeTable(item.Id)">查看</span>
							<span @click="delctTable(item.Id)">删除</span>
						</td>
					</tr>
				</table>
			</article>
			<div class="gaokao-notice">
				<p class="gk-notice-tit">重要提示</p>
				<ul class="gk-notice-li">
					<li>1、本系统仅用于模拟高考志愿填报，不等同于实际的网上填报志愿;</li>
					<li>2、本系统依据高校历年录取数据进行推荐，仅用于志愿填报参考，平台不对实际录取结果做保证，建议考生在实际填报前，进一步咨询目标高校;</li>
					<li>3、本系统公布的专业招生计划可能会有变动，正式填报时请以该省教育考试院公布的为准;</li>
					<li>4、实际填报时，请务必对照省教育考试院本年度最新招生计划确认目标院校招生专业和代码。</li>
				</ul>
			</div>
		</section>

		<div class="popup flex zhong center" v-show="isPop">
			<div class="xiu_center">
				<h6>修改录取信息</h6>
				<div class="xiu_info flex center zhong">
					<el-form ref="form" :model="form" label-width="80px" style="margin-left: -55px;">
						<el-form-item label="分数"><el-input v-model="branch"></el-input></el-form-item>
						<el-form-item label="生源地">
							<el-select v-model="cityCode" placeholder="请选择">
								<el-option v-for="item in cityList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="科目">
							<el-select v-model="subject" placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div class="xiu_bg">
					<div class="xiu_btn flex zhong center">
						<button type="button" @click="onXiuHide()">取消</button>
						<button type="button" @click="onXiuOk()">确定</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
export default {
	data() {
		return {
			cityName: '',
			branchStr: '',
			subjectStr: '',
			List: [],
			cityCode: '',
			branch: '',
			cityList: [],
			options: [
				{
					value: '文科',
					label: '文科'
				},
				{
					value: '理科',
					label: '理科'
				},
				{
					value: '不分文理 ',
					label: '不分文理'
				}
			],
			subject: '',
			isPop: false,
			sel: '',

			form: {
				number: '',
				address: '',
				kemu: ''
			}
		};
	},
	computed: {
		...mapState(['user', 'shop'])
	},
	// 加载
	created() {
		this.$store.state.shop.currentProvince.map(ent => {
			if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
				this.cityList.push(ent);
			}
		});
		var condition = Cookies.get('TBZYcondition');
		if (condition !== undefined) {
			var obj = JSON.parse(condition);
			console.log(obj);
			this.cityName = obj.cityName;
			this.branchStr = obj.branch;
			this.subjectStr = obj.subject;
			this.cityCode = obj.cityCode;
			this.branch = obj.branch;
			this.subject = obj.subject;
		}
		this.GetList(1);
	},
	methods: {
		// 获取列表
		GetList: function(page) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetUserVolunteerTabePage?page=' + page,
				'GET',
				{},
				function(res) {
					console.log('获取列表', res);

					if (res.flag) {
						var list = res.list;
						if (page === 1) {
							that.List = [];
						}
						if (list.length > 0) {
							for (var i = 0; i < list.length; i++) {
								that.List.push(list[i]);
							}

							that.page = page;

							console.log(that.List);
							that.loading = false;
							that.finished = false;
						} else {
							that.loading = false;
							that.finished = true;
						}
					} else {
						that.loading = false;
						// // 数据全部加载完成
						that.finished = true;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		onXiuOk() {
			var that = this;
			if (that.branch === '') {
				that.$util.showError('请输入分数');
				return false;
			}
			if (that.cityCode === '') {
				that.$util.showError('请选择生源地');
				return false;
			}

			if (that.subject === '') {
				that.$util.showError('请选择科目');
				return false;
			}

			that.cityList.map(itme => {
				if (itme.Code === that.cityCode) {
					that.cityName = itme.Name;
				}
			});
			that.branchStr = that.branch;
			that.subjectStr = that.subject;
			that.isPop = false;
		},
		onXiuShow() {
			this.isPop = true;
		},
		onXiuHide() {
			this.isPop = false;
		},
		lukeTable(tabeId) {
			this.$router.push({ path: '/volunteerd', query: { tabeId: tabeId } });
		},
		delctTable(tabeId) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/DeleteUserVolunteerTabe?id=' + tabeId,
				'GET',
				{},
				function(res) {
					console.log('获取', res);

					if (res.flag) {
						that.$util.showOk('删除成功');
					} else {
						that.$util.showError('删除失败');
					}
					that.GetList(1);
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 填报志愿
		goNextb() {
			var that = this;
			if (that.branchStr === '') {
				that.$util.showError('请输入分数');
				return false;
			}
			if (that.cityName === '') {
				that.$util.showError('请选择生源地');
				return false;
			}

			if (that.subjectStr === '') {
				that.$util.showError('请选择科目');
				return false;
			}
			var condition = {
				cityCode: that.cityCode,
				cityName: that.cityName,
				branch: that.branchStr,
				subject: that.subjectStr
			};
			Cookies.set('TBZYcondition', condition);
			that.$router.push('/volunteerb');
		}
	}
};
</script>

<style scoped>
.xiu_info {
	padding: 40px 0;
}

.xiu_btn button {
	width: 100px;
	height: 44px;
	line-height: 44px;
	font-size: 16px;
	margin: 0 30px;
	color: #fff;
	border-radius: 4px;
	background-color: #333;
	cursor: pointer;
}

.xiu_btn button:first-child {
	background-color: #b7b7b7;
}

.xiu_bg {
	padding: 40px 80px;
}

.xiu_center h6 {
	font-size: 16px;
	background-color: #333;
	color: #fff;
	text-align: center;
	line-height: 44px;
}

.xiu_center {
	width: 600px;
	background-color: #fff;
}

.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}

.test-tit {
	font-size: 16px;
	color: #333;
	position: relative;
	padding-left: 20px;
	margin-bottom: 30px;
}
.test-tit::after {
	position: absolute;
	content: '';
	width: 0;
	height: 20px;
	left: 0;
	top: 50%;
	margin-top: -10px;
	border: 2px solid #333;
	border-radius: 50px;
}
/* enroll-info */
.enroll-info {
	padding: 0 40px;
	width: 100%;
	height: auto;
	overflow: hidden;
	border: 1px solid #eee;
	margin-bottom: 40px;
}
.enroll-tit {
	text-align: center;
	font-size: 16px;
	color: #333;
	padding: 35px 0;
}
.enroll-left {
	width: 90%;
	display: flex;
	align-items: center;
}
.enroll-lc01 {
	display: flex;
	align-items: center;
	width: calc(100% / 3);
	justify-content: center;
}
.enroll-lc01 span {
	font-size: 15px;
	color: #333;
	width: 20%;
	text-align: right;
}
.enroll-lc01 input {
	width: 65%;
	height: 40px;
	line-height: 38px;
	border: 1px solid #eee;
	border-radius: 4px;
}
.enroll-right {
	width: 10%;
	text-align: center;
	font-size: 15px;
	color: #333;
	cursor: pointer;
}
/* enroll-table */
.enroll-table {
	width: 100%;
	height: auto;
	overflow: hidden;
	margin-bottom: 40px;
}
.enroll-table-con {
	width: 100%;
	height: auto;
	overflow: hidden;
	border: 1px solid #eee;
}
.enroll-table-con tr {
	border-bottom: 1px solid #eee;
}
.enroll-table-con tr th {
	font-size: 15px;
	color: #333;
	height: 60px;
	line-height: 60px;
	background-color: #eaeaea;
	width: 20%;
}
.enroll-table-con tr td {
	border-right: 1px solid #eee;
	font-size: 15px;
	color: #333;
	text-align: center;
	height: 58px;
	width: 20%;
}
.enroll-table-con tr td span {
	padding: 0 15px;
	font-size: 15px;
	color: #333;
	cursor: pointer;
}
.enroll-table-con tr td span:hover {
	opacity: 0.7;
}
/* gaokao-notice */
.gaokao-notice {
	width: 100%;
	padding: 0 40px 40px 40px;
	height: auto;
	overflow: hidden;
	background-color: #eee;
}
.gk-notice-tit {
	font-size: 17px;
	color: #fa3d32;
	padding: 25px 0;
}
.gk-notice-li {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gk-notice-li li {
	font-size: 15px;
	color: #333;
	padding-bottom: 15px;
}
.gk-notice-li li:last-child {
	padding-bottom: 0px;
}
.gkTest-step {
	padding: 40px;
}
.enroll-btn {
	margin-bottom: 20px;
}
</style>
